// import React, { useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import {setCurrentUser } from "../redux/user/user.actions";
// import ChatServices from "../services/ChatServices";
// const Logout = () => {
//   let history = useHistory();
//   useEffect(() => {
//     const userId = sessionStorage.getItem("userId");
//     ChatServices.setStatus(userId, 'Offline');
//     setCurrentUser({});
//     sessionStorage.clear();
//     localStorage.clear();
//     window.location.href = '/'
//     // history.push('/');
//     // history.go(0);
//   },[]);
//   return null;
// };

// export default Logout;



import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import ChatServices from "../services/ChatServices";

const Logout = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");

    if (userId) {
      ChatServices.setStatus(userId, "Offline");
    }

    dispatch(setCurrentUser(null));

    sessionStorage.clear();   // clears when browser closes automatically
    localStorage.clear();     // optional but safe

    history.replace("/");     // NO window.location.href
  }, [dispatch, history]);

  return null;
};

export default Logout;